import { Avatar as AntAvatar } from "antd";
import { AvatarProps as Props } from "antd/lib/avatar";
import React, { CSSProperties } from "react";

export const Component: Component<{
  readonly children?: Props["children"];
  readonly style?: CSSProperties;
}> = ({ children, style }) => <AntAvatar style={style}>{children}</AntAvatar>;
